<template>
  <div class="work-card" @click="toggleShowWorkModal()">
    <div class="hero-image">
      <img v-if="!imageError" :src="work.images.thumbnail" :alt="work.title" @error="handleImageError" />
      <div v-else class="image-placeholder" :style="{ backgroundColor: placeholderColor }">
        <span>?</span>
      </div>
    </div>
    <div class="card-content">
      <div class="tags">
        <span v-for="stack in work.stacks" :key="stack" class="tag">
          <span class="dot" :style="{ backgroundColor: getTechColor(stack) }"></span>
          {{ stack.toUpperCase() }}
        </span>
      </div>
      <h4 class="title">{{ work.title }}</h4>
    </div>
  </div>
</template>

<script>
import { getTechColor } from "@/constants/techColors";

export default {
  name: "WorkCard",
  props: {
    work: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      imageError: false
    };
  },
  computed: {
    placeholderColor: function () {
      // Generate a consistent pastel color based on title
      const str = this.work.title || 'default';
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }

      // Use hash to create pastel colors (high lightness)
      const h = Math.abs(hash % 360);
      const s = 70 + (Math.abs(hash >> 8) % 20); // 70-90%
      const l = 85 + (Math.abs(hash >> 16) % 10); // 85-95%

      return `hsl(${h}, ${s}%, ${l}%)`;
    }
  },
  methods: {
    toggleShowWorkModal: function () {
      this.$emit("setSelectedWork", this.work);
      this.$store.commit("toggleShowWorkModal");
    },
    handleImageError: function () {
      this.imageError = true;
    },
    getTechColor: function (tech) {
      return getTechColor(tech);
    }
  }
};
</script>

<style lang="scss" scoped>
.work-card {
  background-color: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .hero-image {
    width: 100%;
    padding-top: 56.25%; // 16:9 aspect ratio
    position: relative;
    overflow: hidden;
    background-color: #f3f4f6;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .image-placeholder {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        font-family: 'Inter', 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        font-size: 80px;
        font-weight: 700;
        color: rgba(99, 102, 241, 0.3);
      }
    }
  }

  .card-content {
    padding: 20px;

    .tags {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-bottom: 12px;

      .tag {
        display: inline-flex;
        align-items: center;
        font-size: 10px;
        font-weight: 600;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        color: #374151;

        .dot {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin-right: 6px;
          flex-shrink: 0;
        }
      }
    }

    .title {
      font-family: 'Inter', 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      font-size: 18px;
      font-weight: 700;
      color: #111827;
      margin: 0;
      line-height: 1.4;
      padding-top: 4px;
    }
  }
}
</style>
